import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Grid } from "@material-ui/core";
import FileUpload from "components/FileUpload/FileUploadAffidavite";
import "react-html5-camera-photo/build/css/index.css";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import brandTheme from "brandTheme/Theme";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import OtpModal from "./OtpModal/OtpModal";
import { parseDate } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import ToastModal from "views/components/ToastModal";
import { removeSpecialCharFileName } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";
import Camera from "react-html5-camera-photo";
import DeleteIcon from "@material-ui/icons/Delete";
const Affidavite = ({
  setNext,
  setBack,
  loanApplicationId,
  props,
  editable,
  closeModal,
  status,
  newCustomer,
  existdocumentLink,
  classes,
  submitted,
  loanApplicationNumber,
  loanAccountNumber,
  featureFlags,
  loanType,
  prePledgeLoan,
}) => {
  const navigate = useNavigate();
  const { applicantDetails } = useSelector(
    (state) => state.loanDetail.applicantLoanDetail
  );
  const outletData = featureFlags;
  const enabledNonModalLoanJourney = parseAndSetFlag(
    outletData?.enabledNonModalLoanJourney
  );
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [documentImage1, setDocumentImage1] = useState("");
  const [documentImage1Capture, setDocumentImage1Capture] = useState(false);
  const [documentImage2, setDocumentImage2] = useState("");
  const [documentImage2Capture, setDocumentImage2Capture] = useState(false);
  const [documentImage3, setDocumentImage3] = useState("");
  const [documentImage3Capture, setDocumentImage3Capture] = useState(false);
  const [documentImage4, setDocumentImage4] = useState("");
  const [documentImage4Capture, setDocumentImage4Capture] = useState(false);
  const [documentImage5, setDocumentImage5] = useState("");
  const { ornamentDetail } = useSelector(
    (state) => state.loanDetail?.ornamentDetail
  );
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [applicationLoanId, setLoanAppilcationId] = useState("");
  const [msg, setMsg] = useState("");
  const [head, setHead] = useState("");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [disbursalDates, setDisbursalDates] = useState(new Date());
  const [ornamentRcord, setOrnamentRecord] = useState(ornamentDetail);
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [loanAPPLICATIONID, setLoanAPPLICATIONID] = useState("");
  const [enabledInsurance, setEnabledInsurance] = useState(false);
  const [frontAttachment, setFrontAttachment] = useState("");
  const [backAttachment, setBackAttachment] = useState("");
  const [showCamera, setShowCamera] = useState(false);
  const [cameraType, setCameraType] = useState("");
  let documentImage1Component = useRef();
  let documentImage2Component = useRef();
  let documentImage3Component = useRef();
  let documentImage4Component = useRef();
  let frontPacketImageComponent = useRef();
  let backPacketImageComponent = useRef();

  useEffect(() => {
    if (!editable && loanApplicationId && authToken) {
      getDocuments();
    }
  }, [editable, loanApplicationId, authToken]);

  const getDocuments = async () => {
    try {
      setCallInProgress(true);

      const result = await apiHandler({
        url: endpoint.FIND_DOUMENTS + loanApplicationId,
        method: "GET",
        authToken,
      });

      if (result?.data?.error_code) {
        toastUpdate(
          "Error",
          result?.data?.user_description || "Unable to fetch documents",
          true
        );
        return;
      }

      const data = result?.data?.data || result?.data;

      console.log("FIND_DOUMENTS response:", data);

      setDocumentImage1(data?.vernacularLanguageLink || "");
      setDocumentImage2(data?.signAffidavitLink || "");
      setDocumentImage3(data?.nameAffidavitLink || "");
      setDocumentImage4(data?.dobAffidavitLink || "");

      const packetPhotos = data?.packetPhotoLinks || [];

      setFrontAttachment(packetPhotos?.[0] || "");
      setBackAttachment(packetPhotos?.[1] || "");
    } catch (error) {
      console.error("FIND_DOUMENTS error:", error);

      toastUpdate("Error", "Unable to fetch documents", true);
    } finally {
      setCallInProgress(false);
    }
  };
  const action = async (name, fileName) => {
    let url = "";
    if (name === "customer") {
      GenerateSanctionLetter(
        endpoint.BASE_URL_STAGING +
          "/" +
          endpoint.VERNACULAR_DOCUMENT +
          "?loanAccountNumber=" +
          loanAccountNumber,
        fileName
      );
    } else if (name === "sign") {
      GenerateSanctionLetter(
        endpoint.BASE_URL_STAGING +
          "/" +
          endpoint.SIGN_DOCUMENT +
          "?loanAccountNumber=" +
          loanAccountNumber,
        fileName
      );
    } else if (name === "name") {
      GenerateSanctionLetter(
        endpoint.BASE_URL_STAGING +
          "/" +
          endpoint.NAME_DOCUMENT +
          "?loanAccountNumber=" +
          loanAccountNumber,
        fileName
      );
    } else {
      GenerateSanctionLetter(
        endpoint.BASE_URL_STAGING +
          "/" +
          endpoint.DOB_DOCUMENT +
          "?loanAccountNumber=" +
          loanAccountNumber,
        fileName
      );
    }
  };
  useEffect(() => {
    getInsuranceData();
  }, []);
  const getInsuranceData = async () => {
    const result = await apiHandler({
      url: endpoint.CHECK_FOR_INSURANCE + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setEnabledInsurance(result?.data?.data?.INSURANCE_APPLICABLE);
  };
  const GenerateSanctionLetter = async (apiURL, pdfName) => {
    setCallInProgress(true);
    const result = await axios.get(apiURL, {
      method: "GET",
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + authToken,
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate(
        "Error",
        "There is some problem in Generating Affidavite,please try again",
        true
      );
    }
    const blob = new Blob([new Uint8Array(result.data)], {
      type: "application/pdf",
    });
    const fileURL = URL.createObjectURL(blob);
    // window.open(fileURL);
    const fileName = pdfName + loanAccountNumber;
    const downloadAnchorNode = document.createElement("a");
    downloadAnchorNode.setAttribute("href", fileURL);
    downloadAnchorNode.setAttribute("download", fileName);
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  };
  const UploadAttachment = async (file, type) => {
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(file.name);

    formData.append("file", file, fileName);

    setCallInProgress(true);

    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });

    setCallInProgress(false);

    const uploadedPath = path.data?.name;

    if (uploadedPath) {
      if (type === "front") {
        setFrontAttachment(uploadedPath);
      } else if (type === "back") {
        setBackAttachment(uploadedPath);
      }
    }
  };
  const handleTakePhoto = async (dataUri) => {
    const res = await fetch(dataUri);
    const blob = await res.blob();

    const file = new File([blob], `camera_${Date.now()}.jpg`, {
      type: "image/jpeg",
    });

    UploadAttachment(file, cameraType);
    setShowCamera(false);
  };
  const UploadFile = async (file, type) => {
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(file.name);
    formData.append("file", file, fileName);
    setCallInProgress(true);
    const path = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false);
    const uploadedPath = path.data;
    switch (type) {
      case "documentImage1":
        setDocumentImage1(uploadedPath.name);
        setDocumentImage1Capture(true);
        break;
      case "documentImage2":
        setDocumentImage2(uploadedPath.name);
        setDocumentImage2Capture(true);
        break;
      case "documentImage3":
        setDocumentImage3(uploadedPath.name);
        setDocumentImage3Capture(true);
        break;
      case "documentImage4":
        setDocumentImage4(uploadedPath.name);
        setDocumentImage4Capture(true);
        break;
      default:
        break;
    }
    // handlecreateuserSubmit(uploadedPath.name);
    // setNext(); // kamal
  };
  const handlecanceluser = () => {
    setBack();
  };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const validatePacketPhotos = () => {
    if (!frontAttachment) {
      toastUpdate("Error", "Packet Photo Front is mandatory", true);
      return false;
    }

    if (!backAttachment) {
      toastUpdate("Error", "Packet Photo Back is mandatory", true);
      return false;
    }

    return true;
  };
  const handleSubmitWithValidation = () => {
    const isValid = validatePacketPhotos();

    if (!isValid) return;

    if (!enabledInsurance) {
      proceedApplication();
    } else {
      handleNext();
    }
  };
  const saveUploadDocument = async (id) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: id,
        vernacularLanguageLink: documentImage1,
        signAffidavitLink: documentImage2,
        nameAffidavitLink: documentImage3,
        dobAffidavitLink: documentImage4,
        packetPhotoLinks: [frontAttachment, backAttachment].filter(Boolean),
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      // onClickProceedData(id)
      // GetData();
      onClickProceedData(id);
    }
  };
  const onClickProceedData = async (id) => {
    setCallInProgress(true);
    if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
      const checkResult = await checkForRepledgeAccount(
        authToken,
        prePledgeLoan
      );
      if (checkResult?.data?.error_code) {
        toastUpdate("Error", checkResult?.data?.user_description, true);
        return;
      } else {
        const filteredData =
          checkResult?.data?.filter((item) => Number(item.id) !== Number(id)) ||
          [];
        if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData.map((item) => item?.id).filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
      }
    }
    const result = await apiHandler({
      url: endpoint.DISBURSAL_APPLICATION_LMS + id + `?newDisbursement=true`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      navigate("/loanservice/disbursLms", { state: { from: "" } });
      // GetData();
    }
  };
  const proceedApplication = () => {
    setConfirmationModalHeader("Disbursal");
    setConfirmationModalMsg(
      "Are you sure you want to Proceed this Loan to LMS"
    );
    setConfirmationModal(true);
    setLoanAPPLICATIONID(loanApplicationId);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setLoanAPPLICATIONID("");
  };
  const handlePositiveResponse = async () => {
    let id = loanAPPLICATIONID;
    handleNegativeResponse();
    // Call API to delete loanMarking
    saveUploadDocument(id);
  };
  const handleNext = () => {
    setNext();
  };
  return (
    <div>
      {editable ? (
        <>
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <SubHeader
                label={headerLabel?.afiidavit}
                subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                onlyLabel
              />
            </Grid>
            <Grid container style={{ paddingLeft: "10px" }}>
              {/* Front + Back in one row */}
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  {/* Front */}
                  <Grid item xs={6}>
                    <p style={{ fontSize: 22, fontWeight: "bold" }}>
                      Packet Photo Front
                    </p>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        size="small"
                        className={classes.nextButton1}
                        onClick={() => {
                          setCameraType("front");
                          setShowCamera(true);
                        }}
                      >
                        Camera
                      </Button>

                      <FileUpload
                        document1={setFrontAttachment}
                        supportedMimeType={["image/jpeg", "image/png"]}
                        sendFile={(file) => UploadAttachment(file, "front")}
                        ref={frontPacketImageComponent}
                        type="Attachment"
                      />
                    </div>

                    {frontAttachment && (
                      <img
                        src={frontAttachment}
                        alt="Front"
                        style={{
                          width: "180px",
                          marginTop: "15px",
                          borderRadius: "8px",
                        }}
                      />
                    )}
                  </Grid>

                  {/* Back */}
                  <Grid item xs={6}>
                    <p style={{ fontSize: 22, fontWeight: "bold" }}>
                      Packet Photo Back
                    </p>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        size="small"
                        className={classes.nextButton1}
                        onClick={() => {
                          setCameraType("back");
                          setShowCamera(true);
                        }}
                      >
                        Camera
                      </Button>

                      <FileUpload
                        document1={setBackAttachment}
                        supportedMimeType={["image/jpeg", "image/png"]}
                        sendFile={(file) => UploadAttachment(file, "back")}
                        ref={backPacketImageComponent}
                        type="Attachment"
                      />
                    </div>

                    {backAttachment && (
                      <img
                        src={backAttachment}
                        alt="Back"
                        style={{
                          width: "180px",
                          marginTop: "15px",
                          borderRadius: "8px",
                        }}
                      />
                    )}
                  </Grid>
                </Grid>
              </Grid>

              {/* Camera below */}
              {showCamera && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ marginTop: "15px" }}
                >
                  <Camera
                    onTakePhoto={(dataUri) => handleTakePhoto(dataUri)}
                    isFullscreen={false}
                  />

                  <Button
                    size="small"
                    style={{ margin: "10px 46%" }}
                    className={classes.nextButton1}
                    onClick={() => {
                      setShowCamera(false);
                      setCameraType("");
                    }}
                  >
                    Cancel Camera
                  </Button>
                </Grid>
              )}
              <p style={{ fontSize: 22, fontWeight: "bold" }}>
                Customer Affidavit
              </p>
              <Grid item xs={12} sm={12} md={12} style={{ display: "flex" }}>
                <Button
                  size="small"
                  // className="bg-gradient-theme-left border-0"
                  onClick={() => action("customer", "Customer_Affidavite_")}
                  // style={{marginLeft:"25px",textAlign:"center"}}
                  className={classes.nextButton1}
                  aria-label="upload report"
                  style={{ marginTop: "6px" }}
                >
                  Generate
                </Button>
                <FileUpload
                  document1={setDocumentImage1}
                  addButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  changeButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  removeButtonProps={{
                    color: brandTheme.button2Color,
                    round: false,
                  }}
                  supportedMimeType={["application/pdf"]}
                  sendFile={(file) => UploadFile(file, "documentImage1")}
                  ref={documentImage1Component}
                  type="Affidavite"
                />
                {documentImage1 && (
                  <a
                    href={documentImage1}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      marginLeft: "30%",
                      marginTop: "15px",
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>Sign Affidavit</p>
              <Grid item xs={12} sm={12} md={12} style={{ display: "flex" }}>
                <Button
                  size="small"
                  // className="bg-gradient-theme-left border-0"
                  //   onClick={() => onClickCamera()}
                  // style={{marginLeft:"25px",textAlign:"center"}}
                  onClick={() => action("sign", "Sign_Affidavite_")}
                  className={classes.nextButton1}
                  aria-label="upload report"
                  style={{ marginTop: "6px" }}
                >
                  Generate
                </Button>
                <FileUpload
                  document1={setDocumentImage2}
                  addButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  changeButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  removeButtonProps={{
                    color: brandTheme.button2Color,
                    round: false,
                  }}
                  supportedMimeType={["application/pdf"]}
                  sendFile={(file) => UploadFile(file, "documentImage2")}
                  ref={documentImage2Component}
                  type="Affidavite"
                />
                {documentImage2 && (
                  <a
                    href={documentImage2}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      marginLeft: "30%",
                      marginTop: "15px",
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>Name Affidavit</p>
              <Grid item xs={12} sm={12} md={12} style={{ display: "flex" }}>
                <Button
                  size="small"
                  onClick={() => action("name", "Name_Affidavite_")}
                  className={classes.nextButton1}
                  aria-label="upload report"
                  style={{ marginTop: "6px" }}
                >
                  Generate
                </Button>
                <FileUpload
                  document1={setDocumentImage3}
                  addButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  changeButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  removeButtonProps={{
                    color: brandTheme.button2Color,
                    round: false,
                  }}
                  supportedMimeType={["application/pdf"]}
                  sendFile={(file) => UploadFile(file, "documentImage3")}
                  ref={documentImage3Component}
                  type="Affidavite"
                />
                {documentImage3 && (
                  <a
                    href={documentImage3}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      marginLeft: "30%",
                      marginTop: "15px",
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>
              <p style={{ fontSize: 22, fontWeight: "bold" }}>
                Date Of Birth Affidavit
              </p>
              <Grid item xs={12} sm={12} md={12} style={{ display: "flex" }}>
                <Button
                  size="small"
                  onClick={() => action("dob", "Date_Of_Birth_Affidavite_")}
                  className={classes.nextButton1}
                  aria-label="upload report"
                  style={{ marginTop: "6px" }}
                >
                  Generate
                </Button>
                <FileUpload
                  document1={setDocumentImage4}
                  addButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  changeButtonProps={{
                    color: brandTheme.buttonColor,
                    round: false,
                  }}
                  removeButtonProps={{
                    color: brandTheme.button2Color,
                    round: false,
                  }}
                  supportedMimeType={["application/pdf"]}
                  sendFile={(file) => UploadFile(file, "documentImage4")}
                  ref={documentImage3Component}
                  type="Affidavite"
                />
                {documentImage4 && (
                  <a
                    href={documentImage4}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      marginLeft: "30%",
                      marginTop: "15px",
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>
            </Grid>
          </Grid>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton1}
                onClick={() => handlecanceluser()}
              >
                Back
              </Button>
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton}
                onClick={
                  editable === false ? setNext : handleSubmitWithValidation
                }
              >
                {editable === false
                  ? "Next"
                  : !enabledInsurance
                  ? "Submit"
                  : "Next"}
              </Button>
            </GridItem>
          </GridContainer>
        </>
      ) : (
        <>
          <Grid container>
            <Grid item xs={12} sm={12} md={12}>
              <SubHeader
                label={headerLabel?.afiidavit}
                subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                onlyLabel
              />
            </Grid>

            <Grid container style={{ paddingLeft: "10px" }}>
              {/* Packet Photo Front */}
              <Grid item xs={6}>
                <p style={{ fontSize: 22, fontWeight: "bold" }}>
                  Packet Photo Front
                </p>

                {frontAttachment && (
                  <img
                    src={frontAttachment}
                    alt="Packet Front"
                    style={{
                      width: "180px",
                      marginTop: "15px",
                      borderRadius: "8px",
                    }}
                  />
                )}
              </Grid>

              {/* Packet Photo Back */}
              <Grid item xs={6}>
                <p style={{ fontSize: 22, fontWeight: "bold" }}>
                  Packet Photo Back
                </p>

                {backAttachment && (
                  <img
                    src={backAttachment}
                    alt="Packet Back"
                    style={{
                      width: "180px",
                      marginTop: "15px",
                      borderRadius: "8px",
                    }}
                  />
                )}
              </Grid>

              {/* Customer Affidavit */}
              <Grid item xs={12}>
                <p style={{ fontSize: 22, fontWeight: "bold" }}>
                  Customer Affidavit
                </p>

                {documentImage1 && (
                  <a
                    href={documentImage1}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>

              {/* Sign Affidavit */}
              <Grid item xs={12}>
                <p style={{ fontSize: 22, fontWeight: "bold" }}>
                  Sign Affidavit
                </p>

                {documentImage2 && (
                  <a
                    href={documentImage2}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>

              {/* Name Affidavit */}
              <Grid item xs={12}>
                <p style={{ fontSize: 22, fontWeight: "bold" }}>
                  Name Affidavit
                </p>

                {documentImage3 && (
                  <a
                    href={documentImage3}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>

              {/* DOB Affidavit */}
              <Grid item xs={12}>
                <p style={{ fontSize: 22, fontWeight: "bold" }}>
                  Date Of Birth Affidavit
                </p>

                {documentImage4 && (
                  <a
                    href={documentImage4}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      textDecoration: "underline",
                      color: "#1976d2",
                      cursor: "pointer",
                    }}
                  >
                    View Document
                  </a>
                )}
              </Grid>
            </Grid>
          </Grid>

          {/* Read-only navigation */}
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ textAlign: "end" }}
            >
              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton1}
                onClick={handlecanceluser}
              >
                Back
              </Button>

              <Button
                style={{ margin: "5px" }}
                size="small"
                className={classes.nextButton}
                onClick={setNext}
              >
                Next
              </Button>
            </GridItem>
          </GridContainer>
        </>
      )}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {confirmationModal && (
        <ConfirmationModal
          confirmationModal={confirmationModal}
          confirmationModalHeader={confirmationModalHeader}
          confirmationModalMsg={confirmationModalMsg}
          handleNegativeButton={handleNegativeResponse}
          handlePositiveButton={handlePositiveResponse}
          classes={classes}
        />
      )}
    </div>
  );
};
Affidavite.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};
export default Affidavite;